// courses/course_A02.ts

export const course_A02 = `
  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">1. 촬영장 스태프 구성의 이해: "누구에게 인사해야 할까?"</h4>
    <p style="margin-bottom: 10px; line-height: 1.6;">촬영장은 크게 연출, 촬영, 조명, 동시녹음, 미술, 소품, 의상, 분장 팀 등으로 나뉩니다. 매니저가 특히 자주 소통해야 할 핵심 파트는 다음과 같습니다.</p>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>조감독(AD) & 진행팀:</strong> 스케줄과 현장 운영을 담당합니다. 매니저가 가장 먼저, 가장 자주 소통해야 할 대상입니다.</li>
      <li style="margin-bottom: 8px;"><strong>분장/의상팀:</strong> 배우의 외적인 모습을 책임집니다. 배우의 컨디션이나 수정 사항을 전달할 때 긴밀한 협조가 필요합니다.</li>
      <li><strong>제작팀:</strong> 식사, 장소 제공, 안전 등을 담당합니다. 현장 편의 시설 이용 시 제작팀의 가이드를 잘 따라야 합니다.</li>
    </ul>
  </div>

  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">2. 현장 스태프와의 소통 매너</h4>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>인사는 밝고 먼저 하기:</strong> 현장에 도착하면 감독님뿐만 아니라 각 팀 스태프들에게 "매니저 OOO입니다. 잘 부탁드립니다"라고 밝게 인사합니다.</li>
      <li style="margin-bottom: 8px;"><strong>질문은 조심스럽게:</strong> 촬영 준비로 바쁜 스태프에게 불쑥 질문하기보다는, 흐름을 살핀 뒤 조감독이나 진행팀에게 조용히 묻는 것이 예의입니다.</li>
      <li style="margin-bottom: 8px;"><strong>부탁은 정중하게:</strong> 무언가 필요한 상황(물, 대기 장소 등)이 생기면 당연하다는 태도가 아니라 "혹시 가능할까요?"라며 정중히 요청합니다.</li>
      <li><strong>피드백 수용하기:</strong> 스태프가 아티스트에 대해 요청하는 사항(의상 수정, 동선 확인 등)이 있다면 즉각 수용하고 아티스트에게 부드럽게 전달합니다.</li>
    </ul>
  </div>

  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">3. 촬영 중 절대 금기 사항 (에티켓)</h4>
    <p style="margin-bottom: 10px; line-height: 1.6;">현장의 흐름을 깨지 않기 위해 반드시 지켜야 할 기본 수칙입니다.</p>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>"레디, 액션!" 소리에 정지:</strong> 촬영 사인이 떨어지면 매니저도 그 자리에 멈춰야 합니다. 움직임이나 소음(핸드폰 진동 포함)은 녹음을 방해하고 촬영을 망칠 수 있습니다.</li>
      <li style="margin-bottom: 8px;"><strong>카메라 앵글(화각) 밖 대기:</strong> 배우를 케어하려다 카메라 화면에 걸리지 않도록 항상 모니터 뒤나 지정된 위치에서 대기합니다.</li>
      <li style="margin-bottom: 8px;"><strong>촬영장 사진 촬영 주의:</strong> 현장 스틸 컷을 찍을 때 셔터 소리가 나지 않게 주의하며, 특히 배우의 의상이나 세트장 보안이 필요한 경우 함부로 SNS에 올리지 않습니다.</li>
      <li><strong>사적인 대화 자제:</strong> 스태프들은 각자 맡은 임무에 집중하고 있습니다. 사적인 대화로 업무를 방해하지 않도록 주의합니다.</li>
    </ul>
  </div>

  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">4. 식사 및 휴식 시간의 예절</h4>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>식사 시간 엄수:</strong> 현장에서 정해준 식사 시간을 지킵니다. 아티스트의 식사만 챙기는 것이 아니라, 현장 전체의 흐름에 맞춰 움직입니다.</li>
      <li><strong>대기 장소의 청결:</strong> 배우와 매니저가 머물렀던 대기실이나 차량 주변은 쓰레기 하나 없이 깨끗하게 치우고 나가는 것이 기본입니다. "머문 자리가 아름다운 팀"이라는 인상을 남겨야 합니다.</li>
    </ul>
  </div>

  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">5. 왜 에티켓이 중요한가?</h4>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>다음 작품의 기회:</strong> 현장에서 매너 좋은 매니저와 배우는 감독과 제작진 사이에서 입소문이 납니다. 이는 차기작 캐스팅에 긍정적인 영향을 미칩니다.</li>
      <li><strong>원활한 업무 협조:</strong> 평소 스태프들과 관계가 좋으면, 위급한 상황이나 무리한 부탁을 해야 할 때 훨씬 더 유연하게 도움을 받을 수 있습니다.</li>
    </ul>
  </div>

  <div style="background-color: #f0f9ff; padding: 20px; border-radius: 12px; border-left: 5px solid #0284c7; margin-top: 30px;">
    <strong style="color: #0369a1; font-size: 1.1rem; display: block; margin-bottom: 10px;">💡 교육생을 위한 한 줄 요약</strong>
    <p style="margin: 0; color: #334155; font-style: italic; line-height: 1.6;">
      "매니저의 예의 바른 인사 한마디가 현장 분위기를 바꾸고, 아티스트를 더욱 훌륭한 배우로 만듭니다."
    </p>
  </div>
`;